import React, { Component } from 'react';
import Footer from '../../parts/Footer';
import { Button } from 'react-bootstrap';
import CardCategory from '../../parts/Card Category/index';
import DataCardCategory from '../../json/dataCardCategory.json';
import { FaSearch } from 'react-icons/fa';

class AllProduct extends Component{
    render() {
        return (
            <div>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb ml-2 bg-transparent">
                        <li class="breadcrumb-item"><a class="text-dark" href="#">Merchandise</a></li>
                        <li class="breadcrumb-item"><a class="text-dark" href="#">Baju</a></li>
                        <li class="breadcrumb-item active" aria-current="page">Contoh Baju</li>
                    </ol>
                </nav>

                <form class="form-inline mx-3">
                    <input class="form-control border-0 bg-transparent" type="search" placeholder="Search" aria-label="Search"/>
                    <a href="#" class="text-dark"><FaSearch class="ml-n4"/></a>
                </form>

                <h2>Categories</h2>
                <div class="container row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-4 my-5 mx-auto">
                    <CardCategory data={DataCardCategory}/>
                    <CardCategory data={DataCardCategory}/>
                    <CardCategory data={DataCardCategory}/>
                    <CardCategory data={DataCardCategory}/>
                </div>

                <h2>Product</h2>
                <div class="container row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 my-5 mx-auto">
                    <CardCategory data={DataCardCategory}/>
                    <CardCategory data={DataCardCategory}/>
                    <CardCategory data={DataCardCategory}/>
                    <CardCategory data={DataCardCategory}/>
                    <CardCategory data={DataCardCategory}/>
                    <CardCategory data={DataCardCategory}/>
                    <CardCategory data={DataCardCategory}/>
                </div>

                <Button className="shadow btn btn-primary button d-block mx-auto my-5">Load More</Button>

                <Footer />
            </div>
        )
    }
}

export default AllProduct;